export default {
	OPEN: 'Open',
	PAID: 'Paid',
};
